import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

import { generateCollectionCommands } from './generateCollectionCommands';
import { incomeTypeConfig } from '../components/Overview/CustomerData/Income/incomeTypeConfig.ts';
import type { SchemaIncomeForm } from '../schemas/income.schema';

export function generateIncomeCommands(
    oldData: SchemaLoanRequestResolver_Get['haushalt']['einnahmen'],
    newData: SchemaIncomeForm,
) {
    return generateCollectionCommands(oldData, newData, incomeTypeConfig);
}
